import { Component, OnInit, ViewEncapsulation, Input, SimpleChanges, OnDestroy, OnChanges } from '@angular/core';
import { GameWindowService } from '../../services/gameWindow.services';
import * as _ from 'underscore';
import { takeUntil } from 'rxjs/operators';
import { forkJoin, Subject } from 'rxjs';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { EmitterService } from '../../services/emitter.service';
import { LiveGamesService } from '../../services/live-games.service';
import { GamingUtility } from '../../gaming/gaming.utility';
import { swiperGrid2Config, swiperGrid3Config, sortState } from "../../shared/utility/config";
import { Utility } from '../../shared/utility/utility';
import { AppDetailsService } from '../../services/app-details.services';
import { UserDetailsService } from '../../services/user-details.service';
import { AjaxService } from '../../services/ajax.service';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'app-lobby-game-group',
  templateUrl: './lobby-game-group.component.html',
  styleUrls: ['./lobby-game-group.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LobbyGameGroupComponent implements OnInit, OnDestroy, OnChanges {
  @Input() allGamesPage: boolean = true;
  @Input() isFavourite;
  lobbyDetails:any;
  gameGroupDetails:any;
  destroy$: Subject<boolean> = new Subject();
  langCode: string;
  currentLobby;
  currentGameGroupsList: any;
  gamesGroupedByGameGroup;
  showSwiper = true;
  start = 0;
  end = 17;
  loader = true;
  liveTableData: any;
  activeLobbyBannerTitle: string;
  selectedCategoryType;
  lobbySelectedTab: string;
  gameGroupFromParams:string;
  // tagsList = [];
  swiperDefaultConfig = swiperGrid2Config;
  swiperColumnConfig = swiperGrid3Config;
  showAllGames = false;
  showAllProviders = false;
  gameGroupTypeFromParams:string;
  gameProviderMap: Map<string, string> = new Map<string, string>();
  tagId: string;
  showTabsList = false;
  isUserLoggedIn;
  lastPlayedGamesArray;
  favItemObj = [];
  isHideCommonHeader = false;
  showBannerOnlyHomePage = false;
  seoBannerContentVal;
  isFavGameCheck = {};
  sort: string;
  allGamesByGroup: string;
  isLoadingLastPlayedGames = false;
  windowType: string;
  siteUrlPath: string = environment.siteUrl;
  gameUrlPath: string = environment.gamePath;
  mediaPath = environment.mediaPath;
  providerGroups;
  ngOnChanges(changes: SimpleChanges) {
    if (changes.gameProviderMap) {
      this.gameProviderMap = changes["gameProviderMap"]["currentValue"];
    }
  }

  constructor(
    private gameWindowService:GameWindowService,
    private emitterService: EmitterService,
    private router: Router,
    private liveGamesService: LiveGamesService,
    private activatedRoute:ActivatedRoute,
    private gamingUtils: GamingUtility,
    private utils: Utility,
    public userService: UserDetailsService,
    private appDetails: AppDetailsService,
    private ajaxService: AjaxService,
  ) {
    this.langCode = localStorage.getItem('langCode');
    if('/'+this.langCode != window.location.pathname){
      this.isHideCommonHeader = true;
    }
   this.toggleHomeBanner();

    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.langCode = langCode;
    });
    this.emitterService.liveCasinoTableData$.pipe(takeUntil(this.destroy$)).subscribe(
      tabledata => {
        if (tabledata && !_.isEmpty(tabledata) && !tabledata["error"]) {
          this.liveTableData[tabledata["tableId"]] = tabledata;
        }
      }
    );

    this.emitterService.loginComplete$.pipe(takeUntil(this.destroy$)).subscribe(loginStatus => {
        this.isUserLoggedIn = true;
        this.toggleHomeBanner();
        this.setGameDetails(true);
    });

    this.emitterService.logoutComplete$.pipe(takeUntil(this.destroy$)).subscribe(logoutStatus => {
      if(logoutStatus.includes('true')) {
        this.isUserLoggedIn = false;
        this.setGameDetails(true);
      }
    });

    this.router.events.subscribe((evt) => {
      if(evt instanceof NavigationEnd && (evt.url.includes('casino') || evt.url === "/" + this.langCode)) {
        this.setParamsMap();
        this.setGameDetails();
      }
    });

    this.emitterService.loadHomeBanner$.pipe(takeUntil(this.destroy$)).subscribe(message => {
      this.isUserLoggedIn = this.utils.isUserLoggedIn();
    });

    this.emitterService.favouriteGames$.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.getFavoriteGames(true)
    });

    this.emitterService.emitSortUpdateCallForLobbies$.pipe(takeUntil(this.destroy$)).subscribe((message:any) => {
      this.sort = message;
      this.sortGameGroupGames();
    });
  }

  ngOnInit(): void {
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.emitterService.broadcastHeaderTopicSource("home");
    if(this.allGamesPage) {
      this.emitterService.broadcastHeaderTopicSource("video_slots");
    }
    this.setParamsMap();
    this.setGameDetails(false);
    this.resizeWindow();
  }
   
  toggleHomeBanner(){
    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    if('/'+this.langCode == window.location.pathname || window.location.href.includes('register') && this.isUserLoggedIn){
      this.showBannerOnlyHomePage = true;
      this.isHideCommonHeader = false;
    }else{
      this.showBannerOnlyHomePage = false;
    }
  }
  sortGameGroupGames(){
    if(this.gamesGroupedByGameGroup){
      let self = this;
      this.activatedRoute.queryParams.subscribe(params => {
        self.sort = params["sort"];
        self.allGamesByGroup = JSON.stringify(self.gamesGroupedByGameGroup);
        let sort:any = self.sort ? self.sort : 'none';
        self.sort= sort;
        if(sort) {
            Object.entries(self.gamesGroupedByGameGroup).forEach(([key, gameGroup]) => {
              gameGroup = self.sortGames(sort,gameGroup);
              self.gamesGroupedByGameGroup[key]=gameGroup;
            });
            this.favItemObj = self.sortGamesList(self.sort,self.favItemObj);
            this.lastPlayedGamesArray = self.sortGamesList(self.sort,self.lastPlayedGamesArray);
        }
      })
    }else{
      this.sortGameGroupGames();
    }
   }
   sortGamesList(sort, gamesList){
    if(sort && sort !='none'){
      gamesList = this.sortGames(sort, gamesList)
    }
     return gamesList
   }

   sortGames(status,gamesDetails) {
    gamesDetails = gamesDetails.filter((game)=>{
       game.name = game.name.trim();
       return game
     } )
    let tempArr = [];
    this.gamingUtils.copyGameObject(tempArr, gamesDetails);
    switch (status){
      case sortState.asc:
        return this.gamingUtils.ascendingSort(tempArr);
      case sortState.desc:
        return this.gamingUtils.descendingSort(tempArr);
      case sortState.none:
        return this.sortGamesBasedOnGameGroupOrder(tempArr)
    }
  }

  sortGamesBasedOnGameGroupOrder(games) {
     if(games?.length){
       games[0].gameGroupList.filter((gameGroup)=>{
        if(this.gameWindowService.gamesGroupedByGameGroup[gameGroup?.id]){
          return this.gameWindowService.gamesGroupedByGameGroup[gameGroup.id];
        }
      })
     }
    return games;
   }
  /* Fetching Params and queryparams */ 
  setParamsMap() {
    let paramMap = this.activatedRoute.snapshot;
    this.gameGroupFromParams = paramMap.params["gamegroup"];
    this.gameGroupTypeFromParams = paramMap.params["gamegrouptype"];
    this.tagId = paramMap.queryParams["tagId"];
  }

  /* Setting Game Details */ 
  setGameDetails(isForce=false) {
    this.lobbyDetails = this.gameWindowService.lobbyDetails;
    this.gameGroupDetails = this.gameWindowService.getAllSlotData();
    this.liveTableData = this.liveGamesService.liveTableData ? this.liveGamesService.liveTableData : {};
    this.getFavoriteGames(isForce);

    const lobbyAndGameGroupFetchArray = [];
    if(!this.lobbyDetails || isForce){
      this.lobbyDetails = [];
      if(isForce){
        this.gameWindowService.lobbyDetails = undefined;
      }
      lobbyAndGameGroupFetchArray.push(this.gameWindowService.getLobbies(isForce))
    }

    if(!this.gameGroupDetails){
      lobbyAndGameGroupFetchArray.push(this.gameWindowService.getAllCasinoGames())
    }
    
    if(lobbyAndGameGroupFetchArray.length > 0){
      forkJoin(lobbyAndGameGroupFetchArray).pipe(takeUntil(this.destroy$)).subscribe((lobbyGameGroupDetails:any) =>{
        this.lobbyDetails = this.gameWindowService.lobbyDetails ? this.gameWindowService.lobbyDetails : lobbyGameGroupDetails[0];
        this.gameGroupDetails = this.gameWindowService.getAllSlotData() ? this.gameWindowService.getAllSlotData() : lobbyGameGroupDetails[1];
        this.identifyGameGroupsAndGamesOfLobby()
        this.getFavoriteGames(isForce);
      })
    } else {
      this.identifyGameGroupsAndGamesOfLobby()
    }
  }

  /* Filtering which type of game categories */ 
  identifyGameGroupsAndGamesOfLobby(){
    // this.tagsList = this.gamingUtils.aggregateGamesTags(this.gameGroupDetails);
    this.gameProviderMap = this.gamingUtils.aggregateGameProvider(this.gameGroupDetails);
    this.providerGroups = this.gameWindowService.providerList;
    if(this.gameGroupFromParams === 'allgames') {
      this.showAllGamesResultPage();
    }else if(this.gameGroupFromParams === 'game-providers'){
      this.showAllProvidersResultPage();
    } else if(this.lobbyDetails && this.lobbyDetails.length > 0){
      this.showTabsList = true;
      this.showAllGames = false;
      this.showAllProviders = false;
      this.extractLobby();
      this.getGameGroupDetails();
      if(!this.isUserLoggedIn){
        this.loader = false;
      }
    } else {
      if(this.allGamesPage) {
        this.showAllGamesResultPage();
      } else {
        this.currentGameGroupsList = [];
        this.loader = false;
      }
    }
  }

  extractLobby(){
    const windowLocationArray = window.location.pathname.split("/");
    if(windowLocationArray.length <= 2 || this.gameGroupFromParams === 'home'){
      this.checkCurrentLobby(this.langCode);
    } else if(this.gameGroupFromParams) {
      this.checkCurrentLobby(this.gameGroupFromParams)
    } else {
      this.checkCurrentLobby('');
    }
  }

  checkCurrentLobby(currentWindowLobbyPath) {
    this.currentLobby = _.find(this.lobbyDetails, (lobby) => {
      if(currentWindowLobbyPath !== '') {
        return lobby.multilingualUrlLobby && lobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)] === currentWindowLobbyPath;
      } else {
        return lobby.multilingualUrlLobby && lobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)] !== this.langCode;
      }
    });
  }

  getGameGroupDetails() {

    if(this.currentLobby && this.currentLobby.gameGroupList && this.currentLobby.gameGroupList.length > 0){
        if(this.isUserLoggedIn) {
          this.getLatestPlayedGames();
        }
      this.start = 0;
      let gameGroupGames = JSON.stringify(this.gameWindowService.gamesGroupedByGameGroup)
      this.gamesGroupedByGameGroup = JSON.parse(gameGroupGames);
      if(this.gameGroupTypeFromParams) {
        this.showSwiper = false;
        let gameGroupUrl = this.gameGroupTypeFromParams;
        this.currentGameGroupsList = _.filter(this.currentLobby.gameGroupList, gameGroup => {
          return gameGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(this.langCode)] === gameGroupUrl
        })
        if(this.currentGameGroupsList.length > 0) {
          this.end = this.gamesGroupedByGameGroup[this.currentGameGroupsList[0]['id']] && 
                      this.gamesGroupedByGameGroup[this.currentGameGroupsList[0]['id']].length;
          this.emitterService.broadCastUpdateMetaInfo({
            title: this.currentGameGroupsList[0]['metaTitle'], 
            keywords:  this.currentGameGroupsList[0]['metaTags'], 
            description:  this.currentGameGroupsList[0]['metaDescription']
          });
          this.seoBannerContentVal = this.currentGameGroupsList[0]['content'] ? this.currentGameGroupsList[0]['content'] : null;
        }
      } else {
        this.end = 18;
        this.currentGameGroupsList = this.currentLobby.gameGroupList;
        this.emitterService.broadCastUpdateMetaInfo({
          title: this.currentLobby['metaTitle'], 
          keywords:  this.currentLobby['metaTags'], 
          description:  this.currentLobby['metaDescription']
        });
        this.seoBannerContentVal = this.currentLobby['content'] ? this.currentLobby['content'] : null;
      }
      this.extractHeaderBannerName();
      this.sortGameGroupGames();
    } else {
      this.currentGameGroupsList = [];
      if(this.allGamesPage) {
        this.showAllGamesResultPage();
      }
    }
  }

  /* Filter (Providers || Tags || Show All Games) */ 
  showAllGamesResultPage() {
    this.showAllProviders = false;
    this.showTabsList = true;
    this.showAllGames = true;
    this.loader = false;
  }

  /* Filter (Providers || Tags || Show All Games) */ 
  showAllProvidersResultPage() {
    this.showAllGames = false;
    this.showTabsList = true;
    this.showAllProviders = true;
    this.loader = false;
    _.find(this.lobbyDetails, (lobby) => {
      if(lobby['multilingualUrlLobby'][this.langCode] === "allgames") {
        this.seoBannerContentVal = lobby['content'] ? lobby['content'] : null;
      }
  });
  }
  
  extractHeaderBannerName(){
    if(this.gameGroupTypeFromParams){
      this.activeLobbyBannerTitle = this.currentGameGroupsList[0] && this.currentGameGroupsList[0]['name'];
      this.selectedCategoryType = this.currentGameGroupsList[0] && this.currentGameGroupsList[0]['id'];
    } else if(this.currentLobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)] !==this.langCode){
      this.activeLobbyBannerTitle = this.currentLobby.name;
      this.selectedCategoryType = this.currentLobby['id'];
    } else {
      this.activeLobbyBannerTitle = undefined;
    }    
  }
  
  goToCategory(gameGroup) {
    if(gameGroup && gameGroup.multilingualUrlGameGroup && gameGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(this.langCode)]){
      const gameGroupUrl = gameGroup.multilingualUrlGameGroup[this.utils.getActualMappedLanguage(this.langCode)];
      let lobbyName = this.currentLobby.multilingualUrlLobby[this.utils.getActualMappedLanguage(this.langCode)];
      if(lobbyName === this.utils.getActualMappedLanguage(this.langCode)){
        lobbyName = 'home';
      }

      return '/'+this.langCode + '/casino/' + lobbyName + '/' + gameGroupUrl;
    }
  }

  getBannerTitle(title) {
    this.activeLobbyBannerTitle = title;
    this.selectedCategoryType = 'allgames';
  }

  
 async getLatestPlayedGames() {
    if(this.isUserLoggedIn = this.utils.isUserLoggedIn()){
      this.isLoadingLastPlayedGames = true;
      let self = this;
      let latestPlayedGames = await this.gameWindowService.getRecentlyPlayedGamesList();
      self.lastPlayedGamesArray = latestPlayedGames;
      self.utils.lastPlayedGames = latestPlayedGames;
      self.isLoadingLastPlayedGames = false;
    }
  }

  getFavoriteGames(isForce?) {
    if (this.isUserLoggedIn && this.lobbyDetails) {
      Promise.resolve(this.gameWindowService.getFavouriteGames(isForce))
        .then(favItemObj => {
          
          if (favItemObj && !_.isEmpty(favItemObj)) {
            this.isFavGameCheck = favItemObj;
            if (this.gameGroupDetails) {
             this.updateFavGamesList(favItemObj)
            } else {
              let interval = setInterval(() => {
                if (favItemObj && this.gameGroupDetails) {
                  clearInterval(interval);
                  this.updateFavGamesList(favItemObj)
                }
              }, 1000);
            }
          } else {
            this.favItemObj = [];
            this.isFavGameCheck = {};
            this.loader = false;
          }
        }
        )
    }
  }
  updateFavGamesList(favItemObj){
    let favList = this.gameGroupDetails.filter((item) => {
      return favItemObj[item.gameCode]
    })
   this.favItemObj = this.sortGamesList(this.sort, favList);
    this.loader = false;
  }

  resizeWindow() {
    this.windowType = document.body.clientWidth <= 992 ? 'mobile' : 'desktop';
  }

  gameLauncher(gameType,game): void {
    this.utils.gameLauncher(gameType,game,this.userService, this.gamingUtils);
  }

  setFavouriteGames(gameId) {
    this.isFavourite = this.isFavGameCheck && this.isFavGameCheck[gameId];
    this.utils.setFavouriteGames(gameId, this.isFavourite);
  }

  getGameId(gameGroup){
    if(this.gamesGroupedByGameGroup[gameGroup.id]?.length){
      return this.gamesGroupedByGameGroup[gameGroup.id][0].gameCode
    }
   return ""
  }

  ngOnDestroy(){
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
